import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveBar } from '@nivo/bar';
import numeral from 'numeral';

const DivergingBar = ({ query: { data, loading }, width, axisElement }) => {
  let topData;
  let bottomData;
  if (data) {
    topData = data.map(d => ({
      ...d,
      emotionPercent: d.emotionPercent > 0 ? d.emotionPercent : 0
    }));
    bottomData = data.map(d => ({
      ...d,
      emotionPercent: d.emotionPercent < 0 ? d.emotionPercent : 0
    }));
  }

  const getMaxTop = d => {
    let max = 0;
    d.forEach(o => {
      if (o.emotionPercent > max) {
        max = o.emotionPercent;
      }
    });

    return max > 1 ? max : 1;
  };

  return !loading ? (
    <div style={{ width: '100%', height: '100%', position: 'relative' }}>
      <div className="tvt-charts__diverging-bar-striped-bg" />
      <div className="tvt-charts__diverging-bar-right-bg-filler" />
      <div
        style={{
          width: '100%',
          height: '228px',
          position: 'relative',
          zIndex: 5
        }}
      >
        <ResponsiveBar
          data={topData}
          isInteractive={false}
          labelFormat={d => {
            if (d === 0) {
              return null;
            }
            return (
              <tspan fontFamily="ProximaNovaB" y={-10}>
              {numeral(d).format('0.00')}
              </tspan>
            );
          }}
          indexBy="emotionName"
          keys={['emotionPercent']}
          borderWidth={1}
          borderColor={{ from: 'color', modifiers: [['darker', 0.3]] }}
          markers={[
            {
              axis: 'y',
              value: 0,
              lineStyle: { stroke: '#4f4f4f', strokeWidth: 1 }
            }
          ]}
          margin={{
            top: 30,
            right: 0,
            bottom: 0,
            left: 0
          }}
          padding={0.25}
          colors={({ data }) => data.color}
          axisRight={null}
          axisBottom={null}
          axisLeft={null}
          enableGridX={false}
          enableGridY={false}
          minValue={0}
          maxValue={getMaxTop(topData)}
          theme={{
            tooltip: {
              container: {
                background: '#000'
              }
            }
          }}
          onMouseEnter={(_data, event) => {
            event.target.style.opacity = '.8';
          }}
          onMouseLeave={(_data, event) => {
            event.target.style.opacity = '1';
          }}
          width={width}
        />
      </div>
      {axisElement}
      <div
        style={{
          width: '100%',
          height: '228px',
          position: 'relative',
          marginTop: '60px',
          zIndex: 5
        }}
      >
        <ResponsiveBar
          data={bottomData}
          isInteractive={false}
          labelFormat={d => {
            if (d === 0) {
              return null;
            }
            return (
              <tspan
                fontFamily="ProximaNovaB"
                y={Math.floor(d * -1 * 100 * 2) + 10}
              >
                {numeral(d).format('0.00')}
              </tspan>
            );
          }}
          indexBy="emotionName"
          keys={['emotionPercent']}
          borderWidth={1}
          borderColor={{ from: 'color', modifiers: [['darker', 0.3]] }}
          minValue={-1}
          maxValue={0}
          markers={[
            {
              axis: 'y',
              value: 0,
              lineStyle: { stroke: '#4f4f4f', strokeWidth: 1 }
            }
          ]}
          margin={{
            top: 0,
            right: 0,
            bottom: 30,
            left: 0
          }}
          padding={0.25}
          colors={({ data }) => data.color}
          axisRight={null}
          axisBottom={null}
          axisLeft={null}
          enableGridX={false}
          enableGridY={false}
          theme={{
            tooltip: {
              container: {
                background: '#000'
              }
            }
          }}
          onMouseEnter={(_data, event) => {
            event.target.style.opacity = '.8';
          }}
          onMouseLeave={(_data, event) => {
            event.target.style.opacity = '1';
          }}
          width={width}
        />
      </div>
    </div>
  ) : (
    <div className="tvt-time-chart__loading-state-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="531"
        height="276"
        viewBox="0 0 531 276"
      >
        <defs>
          <linearGradient id="9zy34c60qa" x1="0%" x2="100%" y1="50%" y2="50%">
            <stop offset="0%" stopColor="#EEEEEE" />
            <stop offset="33%" stopColor="#EEEEEE" />
            <stop offset="50%" stopColor="#f5f5f5" />
            <stop offset="67%" stopColor="#EEEEEE" />
            <stop offset="100%" stopColor="#EEEEEE" />
            <animateTransform
              attributeName="gradientTransform"
              type="translate"
              from="-1 0"
              to="1 0"
              begin="0s"
              dur="1.5s"
              repeatCount="indefinite"
            />
          </linearGradient>
        </defs>
        <path
          fill="url(#9zy34c60qa)"
          fillRule="evenodd"
          d="M79 286v10H29v-10h50zm58 0v10H87v-10h50zm58 0v10h-50v-10h50zm58 0v10h-50v-10h50zm58 0v10h-50v-10h50zm58 0v10h-50v-10h50zm58 0v10h-50v-10h50zm58 0v10h-50v-10h50zm58 0v10h-50v-10h50zm7-266v1H21v49h8V45h50v25h471V21h1v254H20V20h530zM29 224h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm173 0H427v50h8v-39h50v39h8v-23h50v23h7v-50zM29 173h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm347 0H253v50h8v-49h50v49h8v-31h50v31h8v-10h50v10h123v-50zM29 122h-8v50h8v-50zm58 0h-8v50h8v-50zm58 0h-8v50h8v-50zm405 0H195v50h8v-31h50v31h297v-50zM29 71h-8v50h8V71zm521 0H79v50h8V80h50v41h8v-8h50v8h355V71z"
          transform="translate(-20 -20)"
        />
      </svg>
    </div>
  );
};

DivergingBar.propTypes = {
  query: PropTypes.shape({
    data: PropTypes.oneOfType([
      PropTypes.shape({}),
      PropTypes.arrayOf(PropTypes.shape({}))
    ]),
    loading: PropTypes.bool
  }).isRequired,
  width: PropTypes.number
};

DivergingBar.defaultProps = {
  width: 330
};

export default DivergingBar;
